export default __webpack_public_path__ + "static/media/esperanto.c66692b7.svg";